import { Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../shared/shared.global-service';
import { selectServiceSettings } from '../../../store/service/service.selectors';
import {
    SERVICE_OPERATIONAL_REPORTS_DEFAULT,
    SERVICE_OPERATIONAL_REPORTS_KEY,
} from '@libs/types/src/services/types/service-settings-operational-report.type';

@Injectable()
export class ServiceOperationalReportsPageStore extends ComponentStoreV2Factory {

    operationalSettings = toSignal(globalStore!.select(
        selectServiceSettings(SERVICE_OPERATIONAL_REPORTS_KEY, SERVICE_OPERATIONAL_REPORTS_DEFAULT),
    ));

}
